<template>
  <div>
    <subscription-desktop v-if="screenType === 'desktop'"></subscription-desktop>
    <subscription-mobile v-else></subscription-mobile>
  </div>
</template>

<script>
import SubscriptionDesktop from "@/components/Pages/Desktop/Dashboard/Subscription/SubscriptionDesktop.vue";
import SubscriptionMobile from "@/components/Pages/Mobile/Dashboard/Subscription/SubscriptionMobile.vue";

export default {
  name: "ProfileMain",
  components: {SubscriptionMobile, SubscriptionDesktop},
  data() {
    return {
      screenType: window.screen.width < 500 ? 'mobile' : window.screen.width < 1000 ? 'tablet' : 'desktop'
    }
  }
}
</script>

<style scoped>

</style>